export default __webpack_public_path__ + "static/media/Path left black.0f29f1e7.svg";